export default "__VITE_ASSET__BueR7Lk3__"